export default {
    // Please list all keys for all items stored in local storage here.  eg. 'test' stores the test variable.
    LocalStorageItems: {
      test: 'test',
    },
  
    /**
     * Get getItem
     *
     * @returns {Promise<any>}
     */
    getItem(name: string): any {
      let value;
      if (window.localStorage) {
        value = window.localStorage.getItem(name);
      }
      if (!value) return null;
      return JSON.parse(value);
    },
  
    setItem(name: string, value: any): any {
      let stringValue = JSON.stringify(value);
      if (window.localStorage) {
        window.localStorage.setItem(name, stringValue);
      }
      return value;
    },
    removeItem(name: string): any {
      if (window.localStorage) {
        window.localStorage.removeItem(name);
      }
    },
    clear() {
      if (window.localStorage) {
        window.localStorage.clear();
      }
    },
  };
  